import axios from 'axios'
import { ApiUrls } from './baseURL';

export const defaultErrorHandler = error => {
  updateLogger(error, 1)
  return Promise.reject(error);
};
export const errorHandler = error => {
  updateLogger(error, 1)
  return Promise.reject(error.response);
};
const getInitializedApi = (contentType, data) => {

  let api = axios.create({
    headers:    {
      "Access-Application": localStorage.getItem("applicationKey"),
      "Client-Token": localStorage.getItem("tenantKey"),
      ApplicationTenantLinkId: localStorage.getItem("applicationTenantLinkId"),
      "WebAccess-Token": localStorage.getItem("tokenKey"),
      "WebAccess-TokenId": localStorage.getItem("tokenId"),
      "Access-Token": localStorage.getItem("token"),
      Email: localStorage.getItem("email"),
      FirstName: localStorage.getItem("firstName"),
      LastName: localStorage.getItem("lastName"),
      UserName: localStorage.getItem("userName"),
      "User-Id": localStorage.getItem("userID"),
      IsExpirationCheckOptional: "true",
      "Content-Type": contentType,
    },
  });
  return api;
};

export const convertToFormUrlencodedValue = params => {
  return Object.keys(params)
    .map(key => {
      return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
    })
    .join('&');
};
export const post = (url, data, contentType = "application/json") => {
  return getInitializedApi(contentType)
    .post(url, data)
    .catch(errorHandler || defaultErrorHandler);
};
export const put = (url, data) => {
  return getInitializedApi('application/json')
    .put(url, data)
    .catch(errorHandler || defaultErrorHandler);
};
export const get = (url, data) => {
  return getInitializedApi('application/json')
    .get(url, data)
    .catch(errorHandler || defaultErrorHandler);
};
export const gets = (url, data) => {
  return getInitializedApis('application/json')
    .get(url, data)
    .catch(errorHandler || defaultErrorHandler);
};
const getInitializedApis= (containType, responseType = 'blob') => {
  const header = {
    Authorization: 'Bearer ' +  localStorage.getItem("token")
  };

  return axios.create({
    responseType: responseType,
    withCredentials: false,
    headers: header.Authorization ? header : {
      'Accept': 'application/json',
      'Content-Type': containType,
      'X-JsonResponseCase': 'camel',
      'X-Requested-With': 'XMLHttpRequest',
      'Access-Control-Allow-Origin': '*',
    },
  });
};
export const getDownloadData = (url, data,Header, config) => {
  return getInitializedApi('application/vnd.ms-excel', 'blob')
    .post(url, data, Header, config)
    .catch(errorHandler || defaultErrorHandler);
};
export const deleteReq = (url, data) => {
  return getInitializedApi('application/json')
    .delete(url, data)
    .catch(errorHandler || defaultErrorHandler);
};


export const updateLogger = async (data, online) => {
  let payload;
  let stringData = typeof(data) === 'string'? data : JSON.stringify(data)
  if (online){
    payload = "$ERR_LOG$ : FULL_ERROR - " + stringData + ", ERROR_RESPONSE - " + (data?.response ? JSON.stringify(data.response) : 'Error In The Flow');
  } else {
    payload = data;
  }
  return getInitializedApi('application/json').post(ApiUrls().UPDATE_LOGS, {"ErrorLogs" : payload}).catch(() => {
    console.log("Error updating logs")
  });
}